/* eslint-disable no-shadow */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable max-len */
import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Box, Grid, styled, Tab, Tabs } from "@mui/material";
import { useQlik } from "../../context/Qlik";
import OnePageCard from "../../components/OnePageCard/OnePageCard";
import { useSelections } from "../../context/Selections";

const LayoutCardsWrapper = styled("div")({
	alignItems: "start",
	display: "flex",
	borderRadius: "16px",
	flexDirection: "row",
	height: "100%",
	justifyContent: "space-between",
	paddingRight: "18px",
	width: "100%",
});

function OnePageMobile({ app, config }) {
	const cards = config?.interactionMix?.containers[0]?.cards ?? null;
	const { selections } = useSelections();
	const [showFullCard, setPosCard] = useState(false);
	const { setSwitchOnDemand } = useQlik();

	const initializeField = () => {
		app.field("%Selecao").selectMatch("Positivação");
	};

	const checkPosCardState = (selections) => {
		if (selections.length) {
			const [monthYearField] = [
				selections.find((s) => s.qField === "Mês/Ano"),
			];

			const selectedMonthYear = monthYearField?.qSelectedCount === 1;

			setPosCard(selectedMonthYear);
		}
	};

	useEffect(() => {
		if (app) {
			initializeField();
		}
	}, []);

	useEffect(() => {
		setSwitchOnDemand(false);
	}, []);

	useEffect(() => {
		checkPosCardState(selections);
	}, [selections]);

	return (
		<div className="app onepage">
			<div className="appContent">
				<LayoutCardsWrapper>
					<Grid container spacing={2}>
						{cards?.map((card, index) => (
							<Grid key={index} item xs={12} sm={6} md={4}>
								<OnePageCard
									app={app}
									config={config}
									key={index}
									KPITitle={card.title.hardTitle}
									valueId={card.nativeObjectIds.valueId}
									goalValueId={
										card.nativeObjectIds.goalValueId
									}
									percentageId={
										card.nativeObjectIds.percentageId
									}
									distributorGraphId={
										card.nativeObjectIds.distributorGraphId
									}
									treemapGraphId={
										card.nativeObjectIds.treemapGraphId
									}
									fullView={index === 2 ? showFullCard : true}
								></OnePageCard>
							</Grid>
						))}
					</Grid>
				</LayoutCardsWrapper>
			</div>
		</div>
	);
}

OnePageMobile.defaultProps = {
	app: null,
	config: {},
};

OnePageMobile.propTypes = {
	app: PropTypes.object,
	config: PropTypes.object,
};

export default OnePageMobile;
